import { ReactNode } from "react";
import { DataProvider } from "./MainContext.tsx";

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
    return (
        <DataProvider>
            {children}
        </DataProvider>
    );
};
